import { widgetConfig } from "../config";
import { buildAttribution } from "./attribution";
import { buildLeadRequest, ILeadApplicant } from "./payload";
import { ILeadResponse, ILeadResult } from "./types";

const GENERIC_ERROR = "Something went wrong. Please try again.";

/**
 * Submit a lead to the proxy backend. The secret leads-hub key lives only in the
 * proxy; the widget presents a public vendor key so the proxy can map it to a
 * tenant and authenticate downstream.
 */
export const submitLead = async (
  applicant: ILeadApplicant,
): Promise<ILeadResult> => {
  const body = buildLeadRequest(applicant, buildAttribution());

  try {
    const response = await fetch(`${widgetConfig.beUrl}/lead`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-vendor-key": widgetConfig.vendorKey,
      },
      body: JSON.stringify(body),
    });

    const data: ILeadResponse | null = await response.json().catch(() => null);

    if (!response.ok || !data?.link) {
      return { data, error: data?.message || GENERIC_ERROR };
    }

    return { data, error: null };
  } catch (err) {
    return {
      data: null,
      error: err instanceof Error ? err.message : GENERIC_ERROR,
    };
  }
};
